function EditContactIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15.998"
      data-name="EditContactIcon - Edit Contact"
      viewBox="0 0 16 15.998"
    >
      <path
        fill="currentColor"
        d="M12.83 8.1l1.058 1.07-8.32 8.367-.958-.119-.1-.951L12.83 8.1m3.2-5.1a.89.89 0 00-.622.258l-1.627 1.626 3.333 3.333 1.626-1.626a.885.885 0 000-1.253l-2.08-2.08A.873.873 0 0016.029 3zm-3.2 2.835L3 15.665V19h3.333l9.83-9.83-3.333-3.335z"
        data-name="Path 10620"
        transform="translate(-3 -3)"
      ></path>
    </svg>
  );
}

export default EditContactIcon;
